import Entity from './entity';
export default Entity.extend({
  precedence: 5,
  type: 'code',
  tagName: 'code',
  hasEditor: false,
  segregated: true,
  attributesToCopy: ['startIndex', 'endIndex', 'href'],
  options: {}
}).reopenClass({
  tagName: 'CODE'
});